import React from 'react';
import NewsCard from './NewsCard';
import Pagination from './Pagination';
import { useFeeds } from '../hooks/useFeeds';
import usePagination from '../hooks/usePagination';

const RSSFeed: React.FC = () => {
  const { feeds, loading, error } = useFeeds();
  const { currentItems, currentPage, totalPages, handlePageChange } = usePagination(feeds, 9);

  return (
    <div id="news-feed">      
      {(loading && feeds.length === 0) ? (
        <div className="flex justify-center items-center min-h-[400px]">
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-[#EC6224] border-t-transparent"></div>
        </div>
      ) : error ? (
        <div className="text-center py-12">
          <p className="text-red-600 mb-4">{error}</p>
        </div>
      ) : (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
            {currentItems.map((item, index) => (
              <NewsCard key={`${item.link}-${index}`} {...item} />
            ))}
          </div>
          
          {feeds.length > 9 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          )}
        </>
      )}
    </div>
  );
};

export default RSSFeed;
